import Siema from 'siema';

const slideshowEls = document.querySelectorAll<HTMLElement>('[data-slideshow]');

slideshowEls.forEach(el => {
	const slides = el.querySelector<HTMLElement>('[data-slides]');
	const next = el.querySelector<HTMLElement>('[data-button-next]');
	const prev = el.querySelector<HTMLElement>('[data-button-prev]');

	if (!slides) return;

	if (slides.children.length <= 1) {
		next?.parentElement?.removeChild(next);
		prev?.parentElement?.removeChild(prev);
		return;
	}

	const slider = new Siema({
		selector: slides,
		draggable:
			'matchMedia' in window ? matchMedia('(hover: none)').matches : false,
		loop: true,
	});

	next?.addEventListener('click', () => {
		slider.next();
	});

	prev?.addEventListener('click', () => {
		slider.prev();
	});
});
